var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOriginalBgImg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 248.38 253.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: url(#linear-gradient-2);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        stroke: url(#linear-gradient-9);\n      }\n\n      .cls-4 {\n        stroke: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        stroke: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        stroke: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        stroke: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        stroke: url(#linear-gradient);\n      }\n\n      .cls-9 {\n        stroke: url(#linear-gradient-8);\n      }\n\n      .cls-10 {\n        stroke: url(#linear-gradient-10);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 248.38,
    y1: 126.82,
    x2: 0,
    y2: 126.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f8eb30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#28a8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65308f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 237.39,
    x2: 10.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 226.39,
    x2: 21.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 215.4,
    x2: 32.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 204.4,
    y1: 126.82,
    x2: 43.98,
    y2: 126.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 193.41,
    y1: 126.82,
    x2: 54.97,
    y2: 126.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 182.41,
    y1: 126.82,
    x2: 65.97,
    y2: 126.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 171.42,
    y1: 126.82,
    x2: 76.96,
    y2: 126.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 160.42,
    y1: 126.82,
    x2: 87.96,
    y2: 126.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 149.43,
    y1: 126.82,
    x2: 98.95,
    y2: 126.82,
    xlinkHref: "#linear-gradient"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 124.19,
    cy: 126.82,
    rx: 123.69,
    ry: 126.32
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 124.19,
    cy: 126.82,
    rx: 112.7,
    ry: 115.09
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 124.19,
    cy: 126.82,
    rx: 101.7,
    ry: 103.86
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 124.19,
    cy: 126.82,
    rx: 90.71,
    ry: 92.64
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 124.19,
    cy: 126.82,
    rx: 79.71,
    ry: 81.41
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 124.19,
    cy: 126.82,
    rx: 68.72,
    ry: 70.18
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 124.19,
    cy: 126.82,
    rx: 57.72,
    ry: 58.95
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 124.19,
    cy: 126.82,
    rx: 46.73,
    ry: 47.72
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 124.19,
    cy: 126.82,
    rx: 35.73,
    ry: 36.49
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 124.19,
    cy: 126.82,
    rx: 24.74,
    ry: 25.26
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginalBgImg4);
export default __webpack_public_path__ + "static/media/original-bg-img-4.5cc1b00e6bb05c5bc3ac97165dbb4edb.svg";
export { ForwardRef as ReactComponent };